import React from 'react';
import FlightReport from './FlightReport';
import http from 'utils/http';
import moment from 'moment';
import cookies from 'utils/cookies';
import AttachmentContainer from './attachment/AttachmentContainer';
import RemarkModal from 'components/pages/common/RemarkModal';

const contractTypes = cookies.get('contract_types') && cookies.get('contract_types') !== 'null' && cookies.get('contract_types').length>0 ? cookies.get('contract_types').sort() : [];
const Role = cookies.get('role');

class FlightReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_Type: contractTypes[0],
      showCompleted: false,
      list: [],
      airlines: [],
      airline: null,
      airlineCode: null,
      role: Role === 'Accounting' ? 'accountant' :'air_rep',
      search: {
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
      },
      anchorEl: null,
      ids: [],
      modalflight: null,
      selectedOption: 'not_ok',
      remark: '',
      records: [],
      modal: false,
      modalData: null,
      modalOpen: false,
      flightReportData: null,
      ctype: null,
      awbType: 'total', 
      docs: [],
      notesList: [],
      popup: false,
      popupAnchorEl: null,
      page: 0,
      pageSize: 10,
      sortModel: [],
      searchText: '',
    };
  }

  componentDidMount() {
    if (this.props.cont_item) {
      //call other functions after getFilters finishes
      Promise.resolve(this.getFilters()).then(() => {
        this.fetchAirlines();
        // this.getList();
      });
    }
  }

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        if(this.state.airline && this.state.airlineCode){
          this.setState({ airlines: response.data.data }, () => { this.getList(); });
        } else {
          this.setState({
            airlines: response.data.data,
            airline: response.data.data[0].id,
            airlineCode: response.data.data[0].code
          }, () => { 
            this.storeFilters();
            this.getList(); 
          });
        }
      });
  };

  getList = () => {
    let rolecheck = this.state.role === 'accountant' ? 'Accounting' : this.state.role === 'air_rep' ? 'Airline Rep' : null;
    http.get(`/approval/flight?from=${this.state.search.from}&to=${this.state.search.to}&type=${this.state.contract_Type}&showcompleted=${this.state.showCompleted}&airline=${this.state.airline}&rolecheck=${rolecheck}`).then((response) => {
      let formattedData = [];
      if (response.data.data && response.data.data.length > 0) {
        formattedData = response.data.data.map((item) => {
          // calculate loose/intact/total awbs, PCS, weight, ulds.
          // calculate ulds, LD3_count, LD7_count, MD_count.
          let loose_awb = 0;
          let intact_awb = 0;
          let total_awb = 0;
          let loose_pcs = 0;
          let intact_pcs = 0;
          let total_pcs = 0;
          let loose_weight = 0;
          let intact_weight = 0;
          let total_weight = 0;
          let loose_uld = 0;
          let intact_uld = 0;
          let total_uld = 0;
          let loose_LD3_count = 0;
          let loose_LD7_count = 0;
          let loose_MD_count = 0;
          let intact_LD3_count = 0;
          let intact_LD7_count = 0;
          let intact_MD_count = 0;
          let total_LD3_count = 0;
          let total_LD7_count = 0;
          let total_MD_count = 0;
          let distinctAWBs = [];
          if (item.flight.flight_uld && item.flight.flight_uld.length > 0) {
            item.flight.flight_uld.map((uld) => {
              if (uld.type === 'Loose') {
                loose_uld += 1;
                total_uld += 1;
                if (uld.flight_awbs && uld.flight_awbs.length > 0) {
                  uld.flight_awbs.map((awb) => {
                    if(awb.is_discrepancy){
                      awb.pcs = parseFloat(awb.d_pcs);
                      awb.wgt = parseFloat(awb.d_wgt);
                    }
                    let found = false;
                    if (!distinctAWBs.includes(awb.awb_no)) {
                      distinctAWBs.push(awb.awb_no);
                    } else {
                      found = true;
                    }
                    // if 'Missing Cargo' or 'Short Shipped'. // get list of uld_index and awb_index from flight_uld where !is_discrepancy and get list of uld_index and awb_index from manifest Data where is_discrepancy. by awb_no
                    if (awb.is_discrepancy && (awb.disc_type === 'Missing Cargo' || awb.disc_type === 'Short Shipped')) {
                      let manifestAWBs = [];
                      let disc_AWBs = [];
                      if (item.flight.flight_uld && item.flight.flight_uld.length > 0) {
                        item.flight.flight_uld.map((uld2) => {
                          if (uld2.type === 'Loose') {
                            //map through flight_awbs and get awb_no
                            if (uld2.flight_awbs && uld2.flight_awbs.length > 0) {
                              uld2.flight_awbs.map((awb2) => {
                                if (awb2.awb_no === awb.awb_no) {
                                  if ( awb2.is_discrepancy === false || !awb2.is_discrepancy || awb2.is_discrepancy === undefined) { 
                                    let obj = {
                                      uld_no: uld2.uld_no,
                                      awb_no: awb2.awb_no,
                                      pcs: awb2.is_discrepancy ? parseInt(awb2.d_pcs || 0) :parseInt(awb2.pcs || 0),
                                      wgt: awb2.is_discrepancy ? parseFloat(awb2.d_wgt || 0) :parseFloat(awb2.wgt || 0),
                                      type: uld2.type,
                                      uld_is_descripancy: uld2.is_discrepancy || false,
                                      is_discrepancy: awb2.is_discrepancy || false,
                                    };
                                    manifestAWBs.push(obj);
                                  } else if (awb2.is_discrepancy === true && (awb2.disc_type === 'Missing Cargo' || awb2.disc_type === 'Short Shipped')) {
                                    let obj = {
                                      uld_no: uld2.uld_no,
                                      awb_no: awb2.awb_no,
                                      pcs: parseInt(awb2.pcs || 0),
                                      wgt: parseFloat(awb2.wgt || 0),
                                      type: uld2.type,
                                      uld_is_descripancy: uld2.is_discrepancy || false,
                                      is_discrepancy: awb2.is_discrepancy || false,
                                      disc_type: awb2.disc_type || '',
                                    };
                                    disc_AWBs.push(obj);
                                  }
                                }
                              });
                            }
                          }
                        });
                      }
                      // console.log('manifestAWBs', manifestAWBs);
                      // console.log('disc_AWBs', disc_AWBs);
                      if (manifestAWBs.length === disc_AWBs.length) {
                        //check if total pcs and weight are same
                        let manifestPcs = 0;
                        let manifestWeight = 0;
                        let discPcs = 0;
                        let discWeight = 0;
                        manifestAWBs.map((awb) => {
                          manifestPcs += awb.pcs;
                          manifestWeight += awb.wgt;
                        });
                        disc_AWBs.map((awb) => {
                          discPcs += awb.pcs;
                          discWeight += awb.wgt;
                        });
                        if (manifestPcs + discPcs === 0 && manifestWeight + discWeight === 0) {
                          loose_awb -= 1;
                          total_awb -= 1;
                        }
                      }
                    } else {
                      loose_awb += found ? 0 : 1;
                      total_awb += found ? 0 : 1;
                    }
                    if (awb.pcs && !isNaN(awb.pcs)) {
                      loose_pcs += awb.pcs;
                      total_pcs += awb.pcs;
                    }
                    if (awb.wgt && !isNaN(awb.wgt)) {
                      loose_weight += parseFloat(awb.wgt);
                      total_weight += parseFloat(awb.wgt);
                    }
                  });
                }
                if (uld?.uld_type?.includes('LD3')) {
                  let add = 1;
                  if (uld?.uld_type?.includes('2X')) {
                    add = 2;
                  }
                  loose_LD3_count += add;
                  total_LD3_count += add;
                } else if (uld?.uld_type?.includes('LD7')) {
                  let add = 1;
                  loose_LD7_count += add;
                  total_LD7_count += add;
                } else if (uld?.uld_type?.includes('MD')) {
                  let add = 1;
                  if (uld?.uld_type?.includes('2X')) {
                    add = 2;
                  }
                  loose_MD_count += add;
                  total_MD_count += add;
                }
              } else if (uld.type === 'Intact') {
                intact_uld += 1;
                total_uld += 1;
                if (uld.flight_awbs && uld.flight_awbs.length > 0) {
                  uld.flight_awbs.map((awb) => {
                    if(awb.is_discrepancy){
                      awb.pcs = parseFloat(awb.d_pcs);
                      awb.wgt = parseFloat(awb.d_wgt);
                    }
                    let found = false;
                    if (!distinctAWBs.includes(awb.awb_no)) {
                      distinctAWBs.push(awb.awb_no);
                    } else {
                      found = true;
                    }
                    // if 'Missing Cargo' or 'Short Shipped'. // get list of uld_index and awb_index from flight_uld where !is_discrepancy and get list of uld_index and awb_index from manifest Data where is_discrepancy. by awb_no
                    if (awb.is_discrepancy && (awb.disc_type === 'Missing Cargo' || awb.disc_type === 'Short Shipped')) {
                      let manifestAWBs = [];
                      let disc_AWBs = [];
                      if (item.flight.flight_uld && item.flight.flight_uld.length > 0) {
                        item.flight.flight_uld.map((uld2) => {
                          if (uld2.type === 'Intact') {
                            //map through flight_awbs and get awb_no
                            if (uld2.flight_awbs && uld2.flight_awbs.length > 0) {
                              uld2.flight_awbs.map((awb2) => {
                                if (awb2.awb_no === awb.awb_no) {
                                  if ( awb2.is_discrepancy === false || !awb2.is_discrepancy || awb2.is_discrepancy === undefined) { 
                                    let obj = {
                                      uld_no: uld2.uld_no,
                                      awb_no: awb2.awb_no,
                                      pcs: awb2.is_discrepancy ? parseInt(awb2.d_pcs || 0) :parseInt(awb2.pcs || 0),
                                      wgt: awb2.is_discrepancy ? parseFloat(awb2.d_wgt || 0) :parseFloat(awb2.wgt || 0),
                                      type: uld2.type,
                                      uld_is_descripancy: uld2.is_discrepancy || false,
                                      is_discrepancy: awb2.is_discrepancy || false,
                                    };
                                    manifestAWBs.push(obj);
                                  } else if (awb2.is_discrepancy === true && (awb2.disc_type === 'Missing Cargo' || awb2.disc_type === 'Short Shipped')) {
                                    let obj = {
                                      uld_no: uld2.uld_no,
                                      awb_no: awb2.awb_no,
                                      pcs: parseInt(awb2.pcs || 0),
                                      wgt: parseFloat(awb2.wgt || 0),
                                      type: uld2.type,
                                      uld_is_descripancy: uld2.is_discrepancy || false,
                                      is_discrepancy: awb2.is_discrepancy || false,
                                      disc_type: awb2.disc_type || '',
                                    };
                                    disc_AWBs.push(obj);
                                  }
                                }
                              });
                            }
                          }
                        });
                      }
                      // console.log('manifestAWBs2', manifestAWBs);
                      // console.log('disc_AWBs2', disc_AWBs);
                      if (manifestAWBs.length === disc_AWBs.length) {
                        //check if total pcs and weight are same
                        let manifestPcs = 0;
                        let manifestWeight = 0;
                        let discPcs = 0;
                        let discWeight = 0;
                        manifestAWBs.map((awb) => {
                          manifestPcs += awb.pcs;
                          manifestWeight += awb.wgt;
                        });
                        disc_AWBs.map((awb) => {
                          discPcs += awb.pcs;
                          discWeight += awb.wgt;
                        });
                        if (manifestPcs + discPcs === 0 && manifestWeight + discWeight === 0) {
                          intact_awb -= 1;
                          total_awb -= 1;
                        }
                      }
                    } else {
                      intact_awb += found ? 0 : 1;
                      total_awb += found ? 0 : 1;
                    }
                    if (awb.pcs && !isNaN(awb.pcs)) {
                      intact_pcs += awb.pcs;
                      total_pcs += awb.pcs;
                    }
                    if (awb.wgt && !isNaN(awb.wgt)) {
                      intact_weight += parseFloat(awb.wgt);
                      total_weight += parseFloat(awb.wgt);
                    }
                  });
                }
                if(uld.potential_discrepancy && uld.is_discrepancy) {
                  //map through flight_awbs and get count of pcs, wgt, d_pcs, d_wgt
                  let disc_pcs = 0;
                  let disc_wgt = 0;
                  let actual_pcs = 0;
                  let actual_wgt = 0;
                  if (uld.flight_awbs && uld.flight_awbs.length > 0) {
                    uld.flight_awbs.map((awb) => {
                      if(awb.is_discrepancy){
                        disc_pcs += parseInt(awb.d_pcs || 0);
                        disc_wgt += parseFloat(awb.d_wgt || 0);
                      } else {
                        actual_pcs += parseInt(awb.pcs || 0);
                        actual_wgt += parseFloat(awb.wgt || 0);
                      }
                    });
                  }
                  if(actual_pcs + disc_pcs === 0 && actual_wgt + disc_wgt === 0){ 
                    //do nothing
                  } else {
                    if (uld?.uld_type?.includes('LD3')) {
                      let add = 1;
                      if (uld?.uld_type?.includes('2X')) {
                        add = 2;
                      }
                      intact_LD3_count += add;
                      total_LD3_count += add;
                    } else if (uld?.uld_type?.includes('LD7')) {
                      let add = 1;
                      intact_LD7_count += add;
                      total_LD7_count += add;
                    } else if (uld?.uld_type?.includes('MD')) {
                      let add = 1;
                      if (uld?.uld_type?.includes('2X')) {
                        add = 2;
                      }
                      intact_MD_count += add;
                      total_MD_count += add;
                    }
                  }
                }else {
                  if (uld?.uld_type?.includes('LD3')) {
                    let add = 1;
                    if (uld?.uld_type?.includes('2X')) {
                      add = 2;
                    }
                    intact_LD3_count += add;
                    total_LD3_count += add;
                  } else if (uld?.uld_type?.includes('LD7')) {
                    let add = 1;
                    intact_LD7_count += add;
                    total_LD7_count += add;
                  } else if (uld?.uld_type?.includes('MD')) {
                    let add = 1;
                    if (uld?.uld_type?.includes('2X')) {
                      add = 2;
                    }
                    intact_MD_count += add;
                    total_MD_count += add;
                  }
                }
              } else {
                total_uld += 1;
                if (uld.flight_awbs && uld.flight_awbs.length > 0) {
                  uld.flight_awbs.map((awb) => {
                    if(awb.is_discrepancy){
                      awb.pcs = parseFloat(awb.d_pcs);
                      awb.wgt = parseFloat(awb.d_wgt);
                    }
                    let found = false;
                    if (!distinctAWBs.includes(awb.awb_no)) {
                      distinctAWBs.push(awb.awb_no);
                    } else {
                      found = true;
                    }
                    total_awb += found? 0 : 1;
                    if (awb.pcs && !isNaN(awb.pcs)) {
                      total_pcs += awb.pcs;
                    }
                    if (awb.wgt && !isNaN(awb.wgt)) {
                      total_weight += parseFloat(awb.wgt);
                    }
                  });
                }
                if (uld?.uld_type?.includes('LD3')) {
                  let add = 1;
                  if (uld?.uld_type?.includes('2X')) {
                    add = 2;
                  }
                  total_LD3_count += add;
                } else if (uld?.uld_type?.includes('LD7')) {
                  let add = 1;
                  total_LD7_count += add;
                } else if (uld?.uld_type?.includes('MD')) {
                  let add = 1;
                  if (uld?.uld_type?.includes('2X')) {
                    add = 2;
                  }
                  total_MD_count += add;
                }
              }
            });
          }
          item.loose_awb = loose_awb;
          item.intact_awb = intact_awb;
          item.total_awb = total_awb;
          item.loose_pcs = loose_pcs;
          item.intact_pcs = intact_pcs;
          item.total_pcs = total_pcs;
          item.loose_weight = loose_weight;
          item.intact_weight = intact_weight;
          item.total_weight = total_weight;
          item.loose_uld = loose_uld;
          item.intact_uld = intact_uld;
          item.total_uld = total_uld;
          item.loose_LD3_count = loose_LD3_count;
          item.loose_LD7_count = loose_LD7_count;
          item.loose_MD_count = loose_MD_count;
          item.intact_LD3_count = intact_LD3_count;
          item.intact_LD7_count = intact_LD7_count;
          item.intact_MD_count = intact_MD_count;
          item.total_LD3_count = total_LD3_count;
          item.total_LD7_count = total_LD7_count;
          item.total_MD_count = total_MD_count;
          return item;
        });
      }
      this.setState({
        records: formattedData,
        list: []
      },()=>{
        this.filterData();
      });
    });
  };

  filterData = () =>{
    let data = this.state.records;
    //filter by airline
    let filteredData = data.filter((item) => {
      return item.flight && item.flight.airline.id === this.state.airline;
    });
    //filter by role 
    filteredData = filteredData.filter((item) => {
      if(this.state.showCompleted === 'false' || this.state.showCompleted === false){
        if(this.state.role === 'accountant'){
          return item.flight && item.flight.airline.id === this.state.airline && ((item.status === 'Finalized' && item.approved_acc === false) || (item.status === 'Rejected' && item.approved_acc === false));
        } else if(this.state.role === 'air_rep'){
          return item.flight && item.flight.airline.id === this.state.airline && (item.status === 'Pending' && item.approved_air === false);
        }
      } else {
        //return all flights
        return item.flight && item.flight.airline.id === this.state.airline;
      }
    });
    // sort by date
    filteredData.sort((a, b) => {
      return new Date(a?.flight?.flight_date) - new Date(b?.flight?.flight_date);
    });

    if (this.state.searchText && this.state.searchText.trim() !== '') {
      const searchLower = this.state.searchText.trim().toLowerCase();
      filteredData = filteredData.filter(item => {
        if (!item.flight || !item.flight.airline) return false;
        const flightNo = `${item.flight.airline.code}${item.flight.flight_no}`.toLowerCase();
        return flightNo.includes(searchLower);
      });
    }

    this.setState({ 
      list: filteredData,
      ids: []
    });
  };

  UpdateFlightReport = () => {
    let ids = [];
    let option = this.state.selectedOption;
    if(this.state.modalflight){
      ids.push(this.state.modalflight.id);
    } else {
      // get all selected ids
      ids = this.state.ids;
    }
    let data = {
      ids: ids,
      status: option === 'comment' ? 'Comment' : option === 'ok' ? 'Approved' : 'Rejected',
      remark: this.state.remark,
    };
    http.post('/flight/reports', data).then((response) => {
      console.log('UpdateFlightReport',response);
      this.getList();
      this.handleReviewClose();
    });
  };

  selectAll = (flag) => {
    if(flag){
      let ids = this.state.list.map((item) => item.id);
      this.setState({ ids: ids });
    } else {
      this.setState({ ids: [] });
    }
  };

  selectFlights = (id, flag)=>{
    console.log('selectFlights', id, flag);
    if(flag){
      this.setState({ ids: [...this.state.ids, id] });
    } else {
      let filtered = this.state.ids.filter((item) => item !== id);
      this.setState({ ids: filtered });
    }
  };
  selectOption = (value) => {
    this.setState({ selectedOption: value });
  };

  setRemark = (value) => {
    this.setState({ remark: value });
  };

  onChangeSearch = (e) => {
    if (e.target.name === 'month') {
      let from = moment(e.target.value).startOf('month').format('YYYY-MM-DD');
      let to = moment(e.target.value).endOf('month').format('YYYY-MM-DD');
      this.setState({
        search: {
          ...this.state.search,
          from: from,
          to: to
        }
      }, () => {
        this.storeFilters();
        this.getList();
      });
    } else {
      this.setState({
        search: {
          ...this.state.search,
          [e.target.name]: e.target.value
        }
      }, () => {
        this.storeFilters();
        this.getList();
      });
    }
  };

  handleContractType = (e) => {
    this.setState({ contract_Type: e.target.value, },()=>{
      this.storeFilters();
      this.getList();
    });
  };

  handleAirlineChange = (e) => {
    let value = e.target.value;
    let airline = this.state.airlines.find(airline => airline.id === value).id;
    let airlineCode = this.state.airlines.find(airline => airline.id === value).code;
    this.setState({
      airline: airline,
      airlineCode: airlineCode,
    },()=>{
      this.storeFilters();
      this.getList();
    });
  };
  handleRoleChange = (e) => {
    this.setState({ role: e.target.value },()=>{
      this.storeFilters();
      // this.filterData(); 
      this.getList();
    });
  };

  handleReview = (anchorEl, flight) => {
    this.setState({ 
      anchorEl,
      modalflight: flight,
      selectedOption: 'not_ok',
    });
  };
  
  handleReviewClose = () => {
    this.setState({ 
      anchorEl: null,
      modalflight: null,
      selectedOption: null,
      remark: '',
    });
  };
  
  handleOpen = (item, modalflight) => {
    this.setState({ 
      modalflight,
      docs: modalflight === 'attached_docs' ? item : null,
    });
  };
  
  handleClose = () => {
    this.setState({ 
      modalflight: null,
      docs: []
    });
  };

  handleRemark = (modal, data) => {
    this.setState({
      modal,
      modalData: data
    });
  };

  handleRemarkClose = () => {
    this.setState({
      modal: false,
      modalData: null
    });
  };

  handleFlight = (data) => {
    this.setState({
      modalOpen: true,
      flightReportData: data.flightId,
      ctype: data.type,
    });
  };

  handleModalClose = () => {
    this.setState({ modalOpen: false });
  };

  storeFilters = () => {
    console.log('storeFilters');
    let filters = {
      search: this.state.search,
      contract_Type: this.state.contract_Type,
      airline: this.state.airline,
      airlineCode: this.state.airlineCode,
      role: this.state.role,
    };
    // set expiry got 1 day.
    cookies.set('approvals', filters, { 
      path: '/', 
      maxAge: 86400 
    });
  };
  getFilters = () => {
    console.log('getFilters');
    let filters = cookies.get('approvals');
    if (filters) {
      if(filters.search){
        this.setState({ search: filters.search });
      }
      if(filters.contract_Type){
        this.setState({ contract_Type: filters.contract_Type });
      }
      if(filters.airline){
        this.setState({ airline: filters.airline });
      }
      if(filters.airlineCode){
        this.setState({ airlineCode: filters.airlineCode });
      }
      // Only set role if it matches the current user's role
      if(filters.role && (
        (Role === 'Accounting' && filters.role === 'accountant') ||
        (Role !== 'Accounting' && filters.role === 'air_rep')
      )){
        this.setState({ role: filters.role });
      }
    }
  };

  handleRadioChange = (event) => {
    this.setState({ awbType: event.target.value });
  };

  handleNotes = (anchorEl, popup, data) => {
    this.setState({ 
      popupAnchorEl: anchorEl,
      popup,
      notesList: data,
    });
  };
  
  closeNotes = () => {
    this.setState({ 
      popupAnchorEl: null, 
      popup: false,
      notesList: [],
    });
  };


  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      pageSize: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  onChangeSearchText = (e) => {
    this.setState({
      searchText: e.target.value,
      page: 0,
    }, () => {
      this.filterData();
    });
  };

  handleAwbSort = () => {
    this.setState((prevState) => {
      const currentModel = prevState.sortModel[0];
      let direction = 'asc';

      if (currentModel?.field === 'awb' && currentModel?.sort === 'asc') {
        direction = 'desc';
      } else if (currentModel?.field === 'awb' && currentModel?.sort === 'desc') {
        direction = null; // remove sort on 3rd click
      }

      return {
        sortModel: direction ? [{
          field: 'awb',
          sort: direction 
        }] : [], 
      };
    });
  };

  handleSortModelChange = (newModel) => {
    this.setState({ sortModel: newModel });
  };

  render() {
    return (
      <>
        <FlightReport
          list={this.state.list}
          search={this.state.search}
          onChangeSearch={this.onChangeSearch}
          anchorEl={this.state.anchorEl}
          handleReviewClose={this.handleReviewClose}
          handleReview={this.handleReview}
          contract_Type={this.state.contract_Type}
          handleContractType={this.handleContractType}
          airlines={this.state.airlines}
          airline={this.state.airline}
          airlineCode={this.state.airlineCode}
          handleAirlineChange={this.handleAirlineChange}
          role={this.state.role}
          handleRoleChange={this.handleRoleChange}
          modalflight={this.state.modalflight}
          UpdateFlightReport={this.UpdateFlightReport}
          selectedOption={this.state.selectedOption}
          selectOption={this.selectOption}
          setRemark={this.setRemark}
          remark={this.state.remark}
          selectFlights={this.selectFlights}
          ids={this.state.ids}
          selectAll={this.selectAll}

          modalOpen={this.state.modalOpen}
          handleFlight={this.handleFlight}
          handleOpen={this.handleOpen}
          flightReportData={this.state.flightReportData}
          ctype={this.state.ctype}
          handleModalClose={this.handleModalClose}

          awbType={this.state.awbType}
          handleRadioChange={this.handleRadioChange}
          handleNotes={this.handleNotes}
          notesList={this.state.notesList}
          closeNotes={this.closeNotes}
          popup={this.state.popup}
          popupAnchorEl={this.state.popupAnchorEl}
          showCompleted={this.state.showCompleted}
          handleShowCompleted={() => this.setState({ showCompleted: !this.state.showCompleted }, () => {
            //fetch list again after toggling showCompleted
            this.selectAll(false);
            this.getList();
          })}
          handleRemark={this.handleRemark}
          searchText={this.state.searchText}
          onChangeSearchText={this.onChangeSearchText}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          page={this.state.page}
          pageSize={this.state.pageSize}
          handleAwbSort={this.handleAwbSort}
          sortModel={this.state.sortModel}
          handleSortModelChange={this.handleSortModelChange}
        />

        {this.state.modalflight === 'attached_docs' &&
          <AttachmentContainer
            handleClose={this.handleClose}
            modal={this.state.modalflight}
            docs={this.state.docs}
          />
        }

        {this.state.modal === 'remark' &&
          <RemarkModal
            modal={this.state.modal}
            onClose={this.handleRemarkClose}
            remark={this.state.modalData}
          />
        }
      </>
    );
  }
}

export default FlightReportContainer;
